import script from "./checkCode.vue?vue&type=script&setup=true&lang=js"
export * from "./checkCode.vue?vue&type=script&setup=true&lang=js"

import "./checkCode.vue?vue&type=style&index=0&id=04149816&scoped=true&lang=css"

import exportComponent from "D:\\workspaceJava\\wlyc\\wlyc\\tianjing-client-web-develop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04149816"]])

export default __exports__